import { render, staticRenderFns } from "./SpecialDays.html?vue&type=template&id=bd73e748&external"
import script from "./SpecialDays.js?vue&type=script&lang=js&external"
export * from "./SpecialDays.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports